import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Height increased to h-20 to give the logo more room to breathe */}
        <div className="flex items-center justify-between h-20">
          
          {/* LOGO SECTION - Acts as the 'Home' link */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2 group transition-transform hover:scale-105 active:scale-95">
              <img 
                src="/logo.png" 
                alt="SiftCard Logo" 
                className="h-12 w-auto object-contain" 
              />
            </Link>
          </div>

          {/* DESKTOP MENU - Removed 'Home' text link */}
          <div className="hidden md:block">
            <div className="flex items-center space-x-10">
              <Link 
                to="/about" 
                className="text-slate-400 hover:text-white text-sm font-medium transition-colors"
              >
                About Us
              </Link>
              <Link 
                to="/how-it-works" 
                className="text-slate-400 hover:text-white text-sm font-medium transition-colors"
              >
                How it Works
              </Link>
              <Link 
                to="/" 
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-full text-sm font-bold transition-all shadow-lg shadow-blue-500/20 active:scale-95"
              >
                Launch App
              </Link>
            </div>
          </div>

          {/* MOBILE MENU BUTTON */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={() => setIsOpen(!isOpen)}
              className="text-slate-400 hover:text-white focus:outline-none p-2"
            >
              <svg className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* MOBILE MENU CONTENT */}
      {isOpen && (
        <div className="md:hidden bg-slate-900 border-b border-slate-800 animate-in fade-in slide-in-from-top-5 duration-200">
          <div className="px-4 pt-2 pb-6 space-y-2">
            <Link 
              to="/about" 
              onClick={() => setIsOpen(false)}
              className="text-slate-300 block px-3 py-4 text-base font-medium border-b border-slate-800/50"
            >
              About Us
            </Link>
            <Link 
              to="/how-it-works" 
              onClick={() => setIsOpen(false)}
              className="text-slate-300 block px-3 py-4 text-base font-medium border-b border-slate-800/50"
            >
              How it Works
            </Link>
            <div className="pt-4">
              <Link 
                to="/" 
                onClick={() => setIsOpen(false)}
                className="w-full bg-blue-600 text-white block px-3 py-4 rounded-xl text-center font-bold"
              >
                Launch App
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
